"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.databaseTimestampDeserialize = void 0;
const deserializeNumber_1 = require("../deserializeNumber");
const deserializeObject_1 = __importDefault(require("../deserializeObject"));
function databaseTimestampDeserialize(value) {
    if (typeof value === 'object') {
        return (0, deserializeObject_1.default)(value);
    }
    else {
        return (0, deserializeNumber_1.deserializeNumber)(value, 0);
    }
}
exports.databaseTimestampDeserialize = databaseTimestampDeserialize;
